var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9989 2.16647C11.9989 0.969967 11.029 0 9.83247 0H2.16647C0.969967 0 0 0.969967 0 2.16647V9.83247C0 11.029 0.969967 11.9989 2.16647 11.9989H5.44293L5.68013 11.0503C5.6844 11.0331 5.68887 11.0161 5.69347 10.999H2.16647C1.5222 10.999 0.999913 10.4767 0.999913 9.83247V3.66635H10.999V5.4878C11.3183 5.3608 11.6613 5.31187 11.9989 5.341V2.16647ZM2.16647 0.999913H9.83247C10.4767 0.999913 10.999 1.5222 10.999 2.16647V2.66643H0.999913V2.16647C0.999913 1.5222 1.5222 0.999913 2.16647 0.999913ZM10.7323 6.44573L6.79767 10.3803C6.56827 10.6097 6.40553 10.8972 6.32687 11.2119L6.0218 12.4323C5.88907 12.963 6.3698 13.4437 6.90053 13.3111L8.12087 13.0059C8.4356 12.9273 8.72307 12.7645 8.95247 12.5351L12.8871 8.60053C13.4821 8.00547 13.4821 7.04073 12.8871 6.44573C12.2921 5.85073 11.3273 5.85073 10.7323 6.44573Z",
    fill: "#5F5F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/editicon.097b0b4c4c952b831f802b0f861ac20b.svg";
export { ForwardRef as ReactComponent };